export default __webpack_public_path__ + "static/media/william.0edd7513.jpg";